<section class="c-section c-section--first c-section--last c-section--open c-section--static">
	<div class="c-section__header u-hidden@md-and-up">
		<h1 class="c-section__title c-section__title--sm">{{ 'Profile.Menu.Limits' | translate }}</h1>
	</div>
	<div class="c-section__content">
		<div class="o-grid">
			<div class="o-grid__cell o-grid__cell--w-100 c-cell">
				<div class="c-card">
					<div class="c-content c-content--xxl c-content--wrapper" [ngStyle]="!vm.initialized && {'min-height': '255px'}">
						<div *ngIf="vm.initialized">
							<div style="padding-bottom: 20px;" *ngIf="vm.hasInsurance()">
								<item-notification icon="attention" [text]="vm.getInsuranceWarning()" [theme]="5"></item-notification>
							</div>
							<div class="o-grid o-grid--wrap">
								<div class="o-grid__cell o-grid__cell--w-100 u-no-p u-osb-sm" *ngFor="let stat of vm.stats">
									<div class="o-grid">
										<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
											<i class="o-icon o-icon--{{ stat.icon }} c-list__icon" aria-hidden="true"></i>
										</div>
										<div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--w-fixed@md-and-up">
											<p class="c-text c-text--spaced c-text--gray u-no-m u-no-wrap@md-and-up">{{ stat.label }}</p>
										</div>
										<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
											<p class="c-text c-text--spaced c-text--right@up-to-md c-text--bold c-text--main u-no-m">{{ stat.value || 0 }}</p>
										</div>
									</div>
								</div>
							</div>
							<p class="c-text c-text--sm u-ost-xl" *ngIf="!vm.user?.service.monthlySubscriptionFee">{{ 'Limits.Change_Limits_Text' | translate }} <a href="mailto:{{vm.contactEmail}}">{{vm.contactEmail}}</a></p>
						</div>
						<loader-overlay *ngIf="!vm.initialized"></loader-overlay>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
